import React from 'react';
import './Loader.css';

// Same file the pre-mount splash in index.html preloads — reused so only one logo is fetched.
const logo = process.env.PUBLIC_URL + '/logo.png';

/**
 * FreeSekho loading screen — the logo "fills up" with colour from the bottom,
 * like water rising in a glass, on a loop.
 *
 *  - fullscreen: cover the whole viewport (use for a blocking load state)
 */
const Loader = ({ fullscreen = false }) => (
  <div className={`fs-loader ${fullscreen ? 'fs-loader--fullscreen' : ''}`} role="status" aria-label="Loading">
    <div className="fs-loader__logo">
      <img src={logo} alt="FreeSekho" className="fs-loader__img fs-loader__img--base" />
      <img src={logo} alt="" aria-hidden="true" className="fs-loader__img fs-loader__img--fill" />
    </div>
    <span className="fs-loader__text">Loading</span>
  </div>
);

export default Loader;
